import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_ITEM_DETAILS_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

/**
 * /trips/75555523444/details/23424234755
 */

export class TripItemDetailsController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public readonly pageId = 'page.Trip.ItemDetail,U,80';
  /**
   * Note that the tripViewId path param is optional since travelers can access the item details
   * page for a cancelled booking that does not have an associated trip.
   */
  public readonly path = '/trips/:tripViewId([a-z0-z-]+)?/details/:tripItemId([a-z0-z-]+)';
  public readonly routeName = 'trip-item-details';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => {
      import(/* webpackPrefetch: true */ '../views/trip-overview-view');

      return import(/* webpackChunkName: "trip-details-product" */ 'views/trip-item-details-view');
    }
  );

  public readonly pageName = 'page.Trip.ItemDetail';
  public readonly clickstreamPageName = 'Trip Item Detail';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_ITEM_DETAILS_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trip-item-details-controller'
    });

    return Promise.resolve();
  }
}
